import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Flex,
  HStack,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  useDisclosure,
  useBreakpointValue,
  useMediaQuery,
  Spacer,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import UserCircleIcon from '../Images/User-Icon-Stande2.0.svg';
import BellIcon from '../Images/Notification-Icon-Stande2.0.svg';
import StandeLogo from '../Images/Stand-logo 1.png';
import StandeLogoDark from '../Images/Stande-logo-white.png';
import { BASE_API_URL } from './config'; 
import { Cog6ToothIcon, ArrowRightOnRectangleIcon, ChevronDownIcon, SunIcon, MoonIcon, SparklesIcon } from '@heroicons/react/24/outline';
import {logout} from "./auth/logout";
import { a, PALETTES } from './appColors';
import { blueButton } from "./buttonStyles";
import SearchCommand from './SearchCommand';
import PaymentPlan from './Landing Page/PaymentPlan';

const Header = ({ isSidebarOpen, isDark = false, onToggleTheme }) => {
  const p = isDark ? PALETTES.dark : PALETTES.light;
  const { isOpen: isPayOpen, onOpen: onPayOpen, onClose: onPayClose } = useDisclosure();
  const [userData, setUserData] = useState({ name: '', photoURL: '' });
  const [isMobile] = useMediaQuery('(max-width: 767px)');
  const [board, setBoard] = useState('Cambridge');
  const [qualification, setQualification] = useState('IGCSE');
  const navigate = useNavigate();

  useEffect(() => {
    const storedName = localStorage.getItem('userName');
    if (storedName) {
      setUserData({ name: storedName, photoURL: localStorage.getItem('userPhotoURL') || '' });
    }
  }, []);


  const handleLogout = async () => {
    try {
      const { data } = await axios.post(`${BASE_API_URL}/api/v1/auth/sign-out`);
      if (data.msg === 'Signed out successfully') {
        localStorage.clear();
        navigate('/login');
      }
    } catch {}
  };

  return (
    <Box
      w="100%"
      p={{ base: '8px 8px', md: '8px 11px' }}
      bg={a.chrome}
      borderBottom="1.5px solid"
      borderColor={a.border}
    >
      <Flex maxW="100%" mx="auto" align="center" justify="space-between" gap={{ base: 3, md: 6 }}>
        <Box as="button" onClick={() => navigate('/')} display="flex" alignItems="center">
          <Image src={isDark ? StandeLogoDark : StandeLogo} alt="Stande" h={isDark ? "18px" : "22px"} w="auto" />
        </Box>

        <Flex flex="1" maxW="740px" mx={{ base: 3, md: 6 }}>
          <SearchCommand />
        </Flex>

        <HStack spacing="12px" align="center">
         
          <HStack spacing="8px" align="center">
            {/* Upgrade lives here now rather than at the foot of the sidebar,
                so it is visible on every screen without scrolling. */}
            <Button
              onClick={onPayOpen}
              aria-label="Upgrade to Premium"
              variant="unstyled"
              display="inline-flex"
              alignItems="center"
              justifyContent="center"
              gap="6px"
              height="34px"
              minW="auto"
              px={{ base: '10px', md: '14px' }}
              borderRadius="full"
              {...blueButton}
              boxShadow="0 6px 16px -8px rgba(2,201,254,0.7)"
              transition="transform 0.15s, filter 0.15s, box-shadow 0.15s"
              _hover={{ ...blueButton._hover, transform: 'translateY(-1px)', boxShadow: '0 10px 22px -8px rgba(2,201,254,0.8)' }}
              _active={{ transform: 'translateY(0)' }}
            >
              <Icon as={SparklesIcon} w="15px" h="15px" />
              <Text fontSize="13px" display={{ base: 'none', md: 'block' }}>
                Upgrade
              </Text>
            </Button>

            <Button
              onClick={onToggleTheme}
              aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minW="34px"
              w="34px"
              h="34px"
              borderRadius="full"
              color={a.text2}
              _hover={{ bg: a.hover }}
            >
              <Icon as={isDark ? SunIcon : MoonIcon} w="20px" h="20px" />
            </Button>
            <Menu>
              <MenuButton as={Button} variant="unstyled" p={0} aria-label="Notifications">
                
                <Image className="app-nav-icon" src={BellIcon} alt="" w="24px" h="24px" />
                
              </MenuButton>
              <MenuList bg={p.surface} borderColor={p.border}>
                <MenuItem bg="transparent" _hover={{ bg: p.hover }} _focus={{ bg: p.hover }}>
                  <Text color={p.textMuted} fontSize="sm">No notifications yet</Text>
                </MenuItem>
              </MenuList>
            </Menu>

            <Menu>
              <MenuButton as={Button} variant="unstyled" p={0} aria-label="Account">
                
                  <Image className="app-nav-icon" src={UserCircleIcon} alt="" w="24px" h="24px" />
             
              </MenuButton>
              <MenuList bg={p.surface} borderColor={p.border}>
                <MenuItem
                  bg="transparent"
                  color={p.text}
                  _hover={{ bg: p.hover }}
                  _focus={{ bg: p.hover }}
                  icon={<Icon as={Cog6ToothIcon} w="20px" h="20px" color={p.textSub} />}
                  onClick={() => navigate('/settings')}
                >
                  Settings
                </MenuItem>
                <MenuItem
                  bg="transparent"
                  color={p.text}
                  _hover={{ bg: p.hover }}
                  _focus={{ bg: p.hover }}
                  icon={<Icon as={ArrowRightOnRectangleIcon} w="20px" h="20px" color={p.textSub} />}
                  onClick={() => {
                    logout({ clearDefaults: false, navigate });
                    navigate("/login");
                  }}
                >
                  Logout
                </MenuItem>
              </MenuList>
            </Menu>
          </HStack>

        </HStack>
      </Flex>

      <Modal isOpen={isPayOpen} onClose={onPayClose} isCentered>
        <ModalOverlay />
        <ModalContent maxW="80vw" maxH="100vh" borderRadius="16px" overflow="hidden" bg={p.surface}>
          <ModalCloseButton color={p.text} />
          <ModalBody p={6}>
            <PaymentPlan />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Header;
